<template>
    <div class="bg-white border border-border rounded-md lg:mb-5 mb-4 hidden lg:block"
        v-if="state.disp_enroll_section && !state.disp_err_msg">
        <div v-for="group in state.bundled_group.filter(group => group.select_plan)" :key="group.id">
            <h6 class="card-title p-4 border-b border-border !m-0">Selected Plan Information
            </h6>
            <p class="text-red-500 px-5 py-2" v-if="state.duplicate_value">
                You have selected duplicate plans. Please correct this mistake.
            </p>
            <div class="p-4">
                <div class="mb-4">
                    <div class="flex justify-between mb-2.5">
                        <p class="content !mb-0">Plan Name</p>
                        <span class="content !text-blackPrimary !mb-0 basis-[50%] text-end lg:basis-[50%] !uppercase">{{
                            group.description }}</span>
                    </div>

                    <div class="flex justify-between mb-2.5">
                        <p class="content !mb-0">Company Name</p>
                        <span class="content !text-blackPrimary !mb-0 basis-[50%] text-end lg:basis-[50%]">{{
                            state.company.company_name }}</span>
                    </div>

                    <div class="flex justify-between mb-2.5">
                        <p class="content !mb-0">State</p>
                        <span class="content !text-blackPrimary !mb-0 basis-[50%] text-end lg:basis-[50%] uppercase">{{ group.state }}</span>
                    </div>

                    <div class="flex justify-between mb-2.5">
                        <p class="content !mb-0">Effective Date</p>
                        <span class="content !text-blackPrimary !mb-0 !font-bold basis-[50%] text-end lg:basis-[50%]">{{
                            new Date(state.eff_date).toLocaleDateString('en-US', {
                                month: '2-digit', day: '2-digit',
                                year: 'numeric'
                            }) }}</span>
                    </div>
                </div>
                <div class="mb-4 p-[15px] border border-border rounded-md bg-primaryLight">
                    <div class="flex justify-between mb-2.5">
                        <p class="content !mb-0" v-if="state.payroll_enrollment !== '1'">
                            <span v-if="state.payment_frequency === 1">Annual</span>
                            <span v-else-if="state.payment_frequency === 2">Semi-Annual</span>
                            <span v-else-if="state.payment_frequency === 4">Per Quarter</span>
                            <span v-else-if="state.payment_frequency === 9">9 Pay Periods</span>
                            <span v-else-if="state.payment_frequency === 12">Per Month</span>
                            <span v-else-if="state.payment_frequency === 20">20 Pay Periods</span>
                            <span v-else-if="state.payment_frequency === 22">22 Pay Periods</span>
                            <span v-else-if="state.payment_frequency === 24">Semi-Monthly</span>
                            <span v-else-if="state.payment_frequency === 26">Bi-Weekly</span>
                            <span v-else-if="state.payment_frequency === 52">Per Week</span>
                        </p>
                        <p class="content !mb-0" v-if="state.payroll_enrollment == '1'">
                            Premium
                        </p>
                        <span class="content !text-blackPrimary !mb-0 !font-bold">${{ group.monthly_premium }}</span>
                    </div>

                    <div class="flex justify-between mb-2.5" v-if="state.payment_method == 'CC'">
                        <p class="content !mb-0">Prorated Premium</p>
                        <span class="content !text-blackPrimary !mb-0 !font-bold">${{ group.prorated_premium }}</span>
                    </div>

                    <div class="flex justify-between mb-2.5" v-if="state.payment_method == 'CC'">
                        <p class="content !mb-0">Service Fee</p>
                        <span class="content !text-blackPrimary !mb-0 !font-bold">${{ state.service_fee }}</span>
                    </div>

                    <div class="flex justify-between mb-0">
                        <p class="content !font-bold !mb-0 !text-blackPrimary">Final Amount</p>
                        <span v-if="state.payment_method != 'Payroll'"
                            class="content !mb-0 !font-bold !text-lg !text-primary">${{ group.total }}</span>
                            <span v-if="state.payment_method == 'Payroll'"
                            class="content !mb-0 !font-bold !text-lg !text-primary">${{ group.total_monthly_prem }}</span>
                    </div>
                </div>
                <div v-if="state.payment_method == 'CC'">
                    <p class="content">
                        Your credit card will be charged premium corresponding with your effective date
                        {{ new Date(state.eff_date).toLocaleDateString('en-US', {
                            month: '2-digit', day: '2-digit',
                            year: 'numeric'
                        }) }} and includes next month's monthly premium. Thereafter, your monthly
                        premium
                        will be processed on the 20th on a recurring monthly cycle beginning {{ state.next_month ? new
                            Date(state.next_month).toLocaleDateString('en-US', { month: '2-digit' }) : '' }}/20/{{
                            state.next_month ? new Date(state.next_month).getFullYear() : '' }}.
                    </p>
                    <p class="content !mb-0">The prorated premium due for the remainder of this month, based
                        on
                        your
                        effective date will be ${{ group.total_prorated_prem }}. Your monthly premium will be
                        ${{group.total_monthly_prem}} with a ${{ state.service_fee }}
                        monthly
                        transaction service fee, for a total of ${{calculateTotal(group.total_monthly_prem,state.service_fee)}} a month.</p>
                </div>
                <div v-if="state.payment_method == 'Payroll'">
                    <div class="content">
                        Effective date : {{ new Date(state.eff_date).toLocaleDateString('en-US', {
                            month: '2-digit', day: '2-digit',
                            year: 'numeric'
                        }) }}

                        <p>Your payroll/settlement deduction will be ${{ group.total_monthly_prem }}</p>
                        <p>Your payroll/settlement deduction is based on the deduction frequency of your company.</p>
                        <p>Payroll/settlement deduction authorization will be submitted to
                            {{ state.company.company_name }}.</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectedPlanInfo",
    props: {
        state: Object
    },
    methods: {
        calculateTotal(total,fee){
            return (parseFloat(total) + parseFloat(fee)).toFixed(2);
        }
    }
};
</script>

<style scoped>
/* Add component-specific styles here if needed */
</style>